// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"83":"68d6e4d5","222":"4051cfaa","478":"49226c94","772":"a34a88bf","810":"03c3b22a","812":"af0504e6","860":"f8a76ec6"}[chunkId] + ".chunk.js";
};